import Reports from '@polleverywhere/core/lib/models/reports'
import populateSkeletons from '../../util/populate_skeletons'
import getStorage from '../../storage'
import ReportSkeleton from './skeleton'
import ErrorModel from '../../models/error'

function fetchReports (reports, page = 0, forceSkeletons = false) {
  if (reports.length === 0 || forceSkeletons) {
    // populate skeletons
    populateSkeletons(reports)
  }

  reports.fetch({ page })
}

export default class State extends Backbone.Model {
  get defaults () {
    return {
      user: null,
      reports: new Reports(),
      report: undefined,
      action: null,
      bulkAction: null,
      pageNumber: 1,
      selecting: false
    }
  }

  messageHistory () {
    getStorage(this.get('user'), 'message')
  }

  showHome (pageNumber = this.get('pageNumber')) {
    this.set({
      report: null,
      action: null,
      pageNumber
    })

    fetchReports(this.get('reports'), pageNumber, true)
  }

  async changeReport (report = null, overrides = {}) {
    if (!report) {
      this.set({
        report,
        action: null
      })
      return
    }

    this.set({
      report: new ReportSkeleton({
        id: report.id,
        name: report.get('name'),
        report_type: report.get('report_type')
      }),
      action: null
    })

    // don't fetch updates if report is an error model
    if (!(report instanceof ErrorModel || report.skeleton)) {
      await report.pollForUpdates()
      await report.fetchResults()
    }
    this.set({ report })
  }

  updateReport () {
    const report = this.get('report')
    report.rerun()
    this.changeReport(report)
  }

  createReport (report) {
    if (!report) { return }

    this.changeReport(report)
    report.save().fail((xhr) => {
      this.changeReport(new ErrorModel(xhr))
    })
  }

  finishBulkAction () {
    // Clear all selected reports.
    this.get('reports').each((report) => {
      report.set({ selected: false })
    })

    this.set({
      bulkAction: null,
      selecting: false
    })
  }

  inspect () {
    const result = super.toJSON()

    // Leaving this info out until it proves useful, so as to not be overwhelming
    delete result.user
    delete result.reports

    return result
  }
}
